import axios from "axios";
import store from "@/store/";

import {
  auth,
  user,
  lender,
  agent,
  brokerage,
  opportunity,
  dnc,
  interactions,
  interviews,
  recordings,
  leads,
  contactCenter,
} from "./api/index";

const api = {
  auth: auth.service(),
  user: user.service(),
  agent: agent.service(),
  lender: lender.service(),
  brokerage: brokerage.service(),
  opportunity: opportunity.service(),
  dnc: dnc.service(),
  interactions: interactions.service(),
  interviews: interviews.service(),
  recordings: recordings.service(),
  leads: leads.service(),
  contactCenter: contactCenter.service(),
  requestHeaders() {
    let headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Cache-control": "no-cache",
    };

    if (
      store.getters["auth/session"] &&
      store.getters["auth/session"].access_token
    ) {
      let token = store.getters["auth/session"].access_token;
      headers["Authorization"] = "Bearer " + token;
    }

    if (store.getters["auth/impUser"] && store.getters["auth/impUser"].id) {
      headers["x-impersonate-uid"] = store.getters["auth/impUser"].id;
    }

    return headers;
  },
  // reAuth() {
  //   if (store.getters["auth/sessionExpiresIn"] > 0) {
  //     store.dispatch("auth/reauth");
  //   }
  // },
  // login(username, password) {
  //   let headers = this.requestHeaders();
  //   headers["Content-Type"] = "application/x-www-form-urlencoded";
  //
  //   let data = new FormData();
  //   data.append("grant_type", "password");
  //   data.append("client_id", "oauthclient");
  //   data.append("username", username);
  //   data.append("password", password);
  //
  //   return axios({
  //     method: "POST",
  //     url: process.env.VUE_APP_API + "/auth/oauth2.0/accessToken",
  //     data: data,
  //     headers: this.requestHeaders()
  //   });
  // },
  forogtPassword(email) {
    let data = {
      emailAddress: email,
    };

    return axios({
      method: "POST",
      url: process.env.VUE_APP_API + "/users-api/users/passwordReset",
      data: data,
      headers: this.requestHeaders(),
    });
  },
  checkInviteCode(code) {
    return axios({
      method: "PUT",
      url: process.env.VUE_APP_API + `/users-api/invites/code/${code}`,
      headers: this.requestHeaders(),
    });
  },
  getMe() {
    // this.reAuth();

    return axios({
      method: "GET",
      url: process.env.VUE_APP_API + `/users-api/users/me`,
      headers: this.requestHeaders(),
    });
  },
  getUser(id) {
    return axios({
      method: "GET",
      url: `${process.env.VUE_APP_API}/users-api/users/${id}`,
      headers: this.requestHeaders(),
    });
  },
  getUsers(params) {
    return axios({
      method: "GET",
      url: process.env.VUE_APP_API + `/users-api/users`,
      headers: this.requestHeaders(),
      params: params,
    });
  },
  createUser(user) {
    // this.reAuth();

    return axios({
      method: "POST",
      url: process.env.VUE_APP_API + `/users-api/users`,
      data: user,
      headers: this.requestHeaders(),
    });
  },
  // Checks if user email/phone record exists
  checkUserContactInfo(params) {
    let headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Cache-control": "no-cache",
    };
    return axios({
      method: "GET",
      url: process.env.VUE_APP_API + `/users-api/users/checkContactInfo`,
      params: params,
      headers: headers,
    });
  },
  updateUser(id, user) {
    // this.reAuth();

    return axios({
      method: "PATCH",
      url: process.env.VUE_APP_API + `/users-api/users/${id}`,
      data: user,
      headers: this.requestHeaders(),
    });
  },
  updateUserRoles(id, role) {
    // this.reAuth();

    return axios({
      method: "POST",
      url: process.env.VUE_APP_API + `/users-api/users/${id}/roles`,
      data: role,
      headers: this.requestHeaders(),
    });
  },
  getAgents(page, size, sort, filter) {
    page = page === undefined ? 0 : page;
    size = size === undefined ? 10 : size;
    sort = sort === undefined ? "name.last,ASC" : sort;

    let name = "";
    let status = "";
    if (filter) {
      // name search
      name =
        filter.name === undefined || filter.name === ""
          ? ""
          : `&name=${filter.name}`;

      // status
      status =
        filter.status === undefined ||
        filter.status === "" ||
        filter.status.length === 0
          ? ""
          : `&status=${filter.status}`;
    }

    return axios({
      method: "GET",
      url:
        process.env.VUE_APP_API +
        `/agents-api/agents?pageIndex=${page}&pageSize=${size}&sort=${sort}${name}${status}`,
      headers: this.requestHeaders(),
    })
      .then((resp) => {
        return {
          resp: resp,
          filter: filter,
        };
      })
      .catch((e) => {
        throw e;
      });
  },
  enrollNewAgent(agent) {
    // this.reAuth();

    return axios({
      method: "POST",
      url: process.env.VUE_APP_API + `/agents-api/agents/enrollment`,
      data: agent,
      headers: this.requestHeaders(),
    });
  },
  updateAgent(id, agent, params) {
    return axios({
      method: "PATCH",
      url: process.env.VUE_APP_API + `/agents-api/agents/${id}`,
      data: agent,
      params: params,
      headers: this.requestHeaders(),
    });
  },
  getAgentReferrals(id) {
    // this.reAuth();

    return axios({
      method: "GET",
      url: process.env.VUE_APP_API + `/agents-api/agents/${id}/referrals`,
      headers: this.requestHeaders(),
    });
  },
  // getBrokerages(page, size, sort, filter) {
  //   // this.reAuth();
  //
  //   page = page === undefined ? 0 : page;
  //   size = size === undefined ? 10 : size;
  //   sort = sort === undefined ? "name,ASC" : sort;
  //
  //   let name = filter === undefined || filter === "" ? "" : `&name=${filter}`;
  //
  //   return axios({
  //     method: "GET",
  //     url:
  //       process.env.VUE_APP_API +
  //       `/agents-api/brokerages?pageIndex=${page}&pageSize=${size}&sort=${sort}${name}`,
  //     headers: this.requestHeaders()
  //   })
  //     .then(resp => {
  //       return {
  //         resp: resp,
  //         filter: filter
  //       };
  //     })
  //     .catch(e => {
  //       throw e;
  //     });
  // },
  getBrokerage(id) {
    // this.reAuth();

    return axios({
      method: "GET",
      url: process.env.VUE_APP_API + `/agents-api/brokerages/${id}`,
      headers: this.requestHeaders(),
    });
  },
  getBoost() {
    return axios({
      method: "GET",
      url: process.env.VUE_APP_API + `/agents-api/agents/boost`,
      headers: this.requestHeaders(),
    });
  },
  // updateBrokerage PUT should not be used anymore,
  // updateBrokerageStatus below is a PATCH replacement
  updateBrokerage(brokerage) {
    // this.reAuth();
    return axios({
      method: "PUT",
      url: process.env.VUE_APP_API + `/agents-api/brokerages/${brokerage.id}`,
      data: brokerage,
      headers: this.requestHeaders(),
    });
  },
  updateBrokerageStatus(brokerageId, status) {
    return axios({
      method: "PATCH",
      url: process.env.VUE_APP_API + `/agents-api/brokerages/${brokerageId}`,
      data: { status: status },
      headers: this.requestHeaders(),
    });
  },
  getRoles() {
    // this.reAuth();

    return axios({
      method: "GET",
      url: process.env.VUE_APP_API + `/users-api/userRoles`,
      headers: this.requestHeaders(),
    });
  },
};

export default api;
